import React, { useState, useEffect, useMemo, useCallback } from 'react'
import HeaderTitle from '_/components/header-title'
import { Grid } from '@material-ui/core'
import { Datagrid, Button } from '@refera/ui-web'
import Theme from '@refera/ui-core'
import { FilterSearch as FilterIcon } from '@refera/ui-icons'
import { navigate } from '@reach/router'
import { useDispatch, useSelector } from 'react-redux'
import { getAiErrorCorrection, getAiAssistants } from '_modules/ai-integration/actions'
import { aiCorrectionsListSelector } from '_modules/ai-integration/selectors'
import { IaTrainigColumns } from './utils/constants'
import { AiTrainingFilterDrawer } from './filters'
import AiCorrectionsModal from './corrections-modal'
import { useToast } from '_/hooks/use-toast'

import useStyles, { datagridStyle } from './styles'

export function AiTrainig() {
  const styles = useStyles()
  const dispatch = useDispatch()
  const { showToast } = useToast()

  const [loading, setLoading] = useState(false)
  const aiErrorCorrections = useSelector(aiCorrectionsListSelector)
  const [page, setPage] = useState(0)
  const [pageSize, setPageSize] = useState(10)
  const [orderBy, setOrderBy] = useState('')

  const [drawerOpen, setDrawerOpen] = useState(false)
  const [filters, setFilters] = useState(0)
  const [applyedfilters, setApplyedFilters] = useState({})
  const [selectedCorrection, setSelectedCorrection] = useState(null)
  const [openEditModal, setOpenEditModal] = useState(false)

  const reloadCorrections = useCallback(() => {
    setLoading(true)
    const payload = { ...filters, page: page + 1, pageSize, orderBy }

    return dispatch(getAiErrorCorrection(payload)).finally(() => setLoading(false))
  }, [dispatch, filters, page, pageSize, orderBy])

  useEffect(() => {
    reloadCorrections()
  }, [filters, page, pageSize, orderBy])

  const handleOrderBy = orderObj => {
    const order = orderObj[0]
    if (!order) {
      setOrderBy('createdAt')
      return
    }

    const { field, sort } = order
    setOrderBy(`${sort === 'desc' ? '-' : ''}${field}`)
  }

  const filterIconColor = useMemo(() => {
    return loading ? Theme.Colors.Grayscale.ThirtyTwo : Theme.Colors.Primary.Base
  }, [loading])

  const handleFilters = () => setDrawerOpen(prevState => !prevState)

  useEffect(() => {
    dispatch(getAiAssistants())
  }, [])

  const handleFilter = useCallback(
    payload => {
      setLoading(true)

      setApplyedFilters(payload)
      setFilters(payload)

      return dispatch(getAiErrorCorrection({ pageSize, page: page + 1, orderBy, ...payload }))
        .then(() => {
          setDrawerOpen(false)
          setPage(0)
          return setLoading(false)
        })
        .catch(() => {
          showToast({ type: 'error', message: 'Ocorreu um erro ao buscar os registros.' })
          return setLoading(false)
        })
    },
    [pageSize, page, orderBy]
  )

  const handleEditCorrection = useCallback(event => {
    setSelectedCorrection(event.row)
    setOpenEditModal(true)
  }, [])

  return (
    <Grid className={styles.container}>
      <HeaderTitle title="Treinamento de IA" backButtonAction={() => navigate(-1)}>
        <Button
          variant="ghost"
          startIcon={<FilterIcon color={filterIconColor} />}
          onClick={handleFilters}
          disabled={loading}
        >
          Filtros
        </Button>
      </HeaderTitle>

      <Grid className={styles.tableContainer}>
        <Grid className={styles.mainTable}>
          <Datagrid
            rows={aiErrorCorrections.results ?? []}
            rowCount={aiErrorCorrections.count ?? 0}
            loading={loading}
            getRowId={row => row.id}
            columns={IaTrainigColumns(styles)}
            paginationMode="server"
            onPageChange={setPage}
            page={page}
            onPageSizeChange={setPageSize}
            pageSize={pageSize}
            onSortModelChange={handleOrderBy}
            sx={datagridStyle}
            onRowClick={handleEditCorrection}
          />
        </Grid>
      </Grid>
      <AiTrainingFilterDrawer
        open={drawerOpen}
        close={() => setDrawerOpen(false)}
        filters={applyedfilters}
        setFilters={setFilters}
        applyFilters={handleFilter}
      />
      <AiCorrectionsModal
        correction={selectedCorrection}
        open={openEditModal}
        setOpen={setOpenEditModal}
        reloadCorrections={reloadCorrections}
      />
    </Grid>
  )
}
